var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    fill: "none",
    viewBox: "0 0 26 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#383B45",
    fillRule: "evenodd",
    d: "M11.556.975c5.914 0 10.707 4.554 10.707 10.171 0 2.598-1.025 4.97-2.713 6.767l5.997 5.566a.717.717 0 0 1 .013 1.051.81.81 0 0 1-1.106.012l-6.028-5.594c-1.86 1.479-4.255 2.369-6.87 2.369-5.914 0-10.707-4.553-10.707-10.171S5.642.976 11.556.976m0 1.486c-5.05 0-9.143 3.888-9.143 8.685s4.093 8.685 9.143 8.685c5.049 0 9.142-3.888 9.142-8.685s-4.093-8.685-9.142-8.685",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;